module.exports = __webpack_public_path__ + "img/science-bg.5969dfe.png";